import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Chart } from "chart.js/auto";
import { TreemapController, TreemapElement } from "chartjs-chart-treemap";

import { Constants } from "../../../constants/constants";
import { Language } from "../../../constants/enums";
import { TpDetailedSectorsResponse, TpSectorItem } from "../../../models";
import { LanguageService } from "../../../services";

@Component({
  selector: "adaa-tp-sectors",
  imports: [],
  templateUrl: "./tp-sectors.html",
  styleUrl: "./tp-sectors.scss",
})
export class TpSectorsComponent implements OnInit, AfterViewInit, OnDestroy {
  sectors = input.required<TpDetailedSectorsResponse>();
  @Output() cardClicked = new EventEmitter<number>();

  private _elementRef = inject(ElementRef);
  private _languageService = inject(LanguageService);

  private _chart: Chart<"treemap", TpSectorItem[], unknown> | undefined = undefined;

  public ngOnInit(): void {
    //THIS CHART IS NOT FROM CHARTJS THATS WHY YOU NEED TO REGISTER IT
    //THE CONIFG IS HERE BEACUSE IT'S NOT SIMILAR TO THE REST OF THE CHARTS
    Chart.register(TreemapController, TreemapElement);
  }

  public ngOnDestroy(): void {
    if (!this._chart) return;
    this._chart.destroy();
    this._chart = undefined;
  }

  public ngAfterViewInit(): void {
    const data = this.sectors().counts;
    const isRTL = this._languageService.current() === Language.Arabic;
    const cardClicked = this.cardClicked;

    const ctx = this._elementRef.nativeElement.querySelector(`#tpSectors`);

    this._chart = new Chart(ctx, {
      type: "treemap",
      data: {
        datasets: [
          {
            rtl: isRTL,
            key: "count",
            data: this.sectors().counts,
            borderWidth: 1,
            backgroundColor(e) {
              if (e.dataIndex == undefined) e.dataIndex = 0;
              return data[e.dataIndex]?.color || Constants.COLOR_CODES[Constants.CONSTANT_COLORS.EVALUATION_GRAY];
            },
            labels: {
              display: true,
              color: "#ffffff",
              font: {
                weight: "bold",
                family: "Open Sans, NotoKufiArabic",
              },
              formatter: (e) => {
                const label = !isRTL ? data[e.dataIndex].nameEN : data[e.dataIndex].nameAE;

                const boxWidth = e.raw.w;

                const avgCharWidth = 8; // adjust based on font size
                const maxCharsPerLine = Math.floor(boxWidth / avgCharWidth);

                const words = label.split(" ");
                const lines: string[] = [];
                let currentLine = "";

                if (e.raw.w < 50) return "";

                for (const word of words) {
                  if ((currentLine + word).length <= maxCharsPerLine) {
                    currentLine += (currentLine ? " " : "") + word;
                  } else {
                    if (currentLine) lines.push(currentLine);
                    currentLine = word;
                  }
                }

                if (currentLine) lines.push(currentLine);

                return lines;
              },
            },
          },
        ],
      },
      options: {
        onClick(_event, element) {
          if (element[0] && data[element[0].index]) cardClicked.emit(data[element[0].index].id);
        },
        plugins: {
          datalabels: {
            display: false,
          },
          legend: { display: false },
          tooltip: {
            rtl: isRTL,
            bodyFont: {
              weight: "bold",
              family: "Open Sans, NotoKufiArabic",
            },
            callbacks: {
              title() {
                return "";
              },
              label(e) {
                if (e.dataIndex == undefined) e.dataIndex = 0;

                return ` ${!isRTL ? data[e.dataIndex].nameEN : data[e.dataIndex].nameAE}: ${data[e.dataIndex].count}`;
              },
            },
          },
        },
      },
    });
  }
}
